// extracted by mini-css-extract-plugin
export default {"mapCard":"MindMap_mapCard__Ro64q"};